// Fonction spéciale sans génération de code JS côté client (traitement côté worker, mode "file")
export default {
  functionKey: "NB COLONNE",
  title: "NB COLONNE",
  group: "Calcul colonne",
  origin: [],
  multiOrigin: true,
  arguments: [],
  maxArguments: 1,
  showTypeOptions: { origin: false, target: false, arguments: false },
  requiredArguments: [{ argumentKey: "Label", name: "Libellé du résultat" }],
  expectedArguments: [
    { name: "Libellé du résultat", argumentKey: "Label", single: true, initialValue: "Nb" }
  ],
  description: "Compte le nombre de valeurs numériques d'une ou plusieurs colonnes (lignes filtrées par les conditions).",
  details: "Compte le nombre de valeurs numériques d'une ou plusieurs colonnes d'origine (sur les lignes respectant les conditions du bloc — plusieurs colonnes sont combinées en un seul ensemble). Ajoute une nouvelle ligne de résultat (colonnes __fonction__ / __resultat__) sans modifier les lignes existantes.",
  isStarred: false,

  generate: null
}
